module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Black-WebM-da0828a54cbc22459ff7936a66c86402.woff2";